export const Create = {
  FilesToUpload: "filesToUpload" as const,
  Type: "type" as const,
  ReceiptDate: "receiptDate" as const,
  ReceiptAmount: "receiptAmount" as const,
  ReceiptCurrency: "receiptCurrency" as const,
  ReceiptCategoryId: "receiptCategoryId" as const,
  ReceiptCategoryType: "receiptCategoryType" as const,
  ReceiptCategory: "receiptCategory" as const,
  ReceiptPaymentMethodId: "receiptPaymentMethodId" as const,
  ReceiptPaymentMethod: "receiptPaymentMethod" as const,
  ReceiptPersons: "receiptPersons" as const,
  Dimensions: "dimensions" as const,
  HasDimensions: "hasDimensions" as const,
  ReceiptPurpose: "receiptPurpose" as const,
  ReceiptOtherExplanation: "receiptOtherExplanation" as const,
  ReceiptCanBePayedOut: "receiptCanBePayedOut" as const,
  ReceiptPersonNumber: "receiptPersonNumber" as const,
  ReceiptBankAccount: "receiptBankAccount" as const,
  ReceiptClearingNumber: "receiptClearingNumber" as const,
  InvoiceAmount: "invoiceAmount" as const,
  InvoiceVATAmount: "invoiceVATAmount" as const,
  InvoicePaymentNumberType: "invoicePaymentNumberType" as const,
  InvoiceWarning: "invoiceWarning" as const,
  SupplierOrgNr: "supplierOrgNr" as const,
  SupplierBg: "supplierBg" as const,
  SupplierPg: "supplierPg" as const,
  SupplierIBAN: "supplierIBAN" as const,
  DocumentSubject: "documentSubject" as const,
  IsDocumentDraft: "isDocumentDraft" as const,
  IsReceiptManualPayment: "isReceiptManualPayment" as const,
  InternalNote: "internalNote" as const,
}

export const CreateNew = {
  FilesToUpload: "filesToUpload" as const,
  Type: "type" as const,
  Receipt: "receipt" as const,
  IncomingInvoice: "incomingInvoice" as const,
  Document: "document" as const,
  IsDocumentDraft: "isDocumentDraft" as const,
}

export const CreateReceipt = {
  Date: "date" as const,
  Amount: "amount" as const,
  Currency: "currency" as const,
  Category: "category" as const,
  CategoryType: "categoryType" as const,
  PaymentMethod: "paymentMethod" as const,
  Persons: "persons" as const,
  Dimensions: "dimensions" as const,
  HasDimensions: "hasDimensions" as const,
  Purpose: "purpose" as const,
  OtherExplanation: "otherExplanation" as const,
  CanBePayedOut: "canBePayedOut" as const,
  PersonNumber: "personNumber" as const,
  BankAccount: "bankAccount" as const,
  ClearingNumber: "clearingNumber" as const,
  IsManualPayment: "isManualPayment" as const,
  InternalNote: "internalNote" as const,
  IsOtherPaymentMethod: "isOtherPaymentMethod" as const,
  Comment: "comment" as const,
  OtherPaymentMethodExplanation: "otherPaymentMethodExplanation" as const,
}

export const CreateIncomingInvoice = {
}

export const SIEFilter = {
  FileName: "fileName" as const,
  UploadedDate: "uploadedDate" as const,
  UploadedById: "uploadedById" as const,
  UploadedByName: "uploadedByName" as const,
}

export const UploadSIE = {
  Files: "files" as const,
  Comment: "comment" as const,
}

export const ExportSIE = {
  FinancialYear: "financialYear" as const,
  FinancialYearId: "financialYearId" as const,
  DateRange: "dateRange" as const,
}

export const EditGenericDocument = {
  Name: "name" as const,
}

export const GenericDocumentFilter = {
  Description: "description" as const,
  CreatedDate: "createdDate" as const,
  UpdatedDate: "updatedDate" as const,
  States: "states" as const,
}

export const UploadGenericDocument = {
  Files: "files" as const,
  Comment: "comment" as const,
}

export const SupplementaryMaterial = {
  Files: "files" as const,
  Comment: "comment" as const,
}

export const UploadSharedDocument = {
  Files: "files" as const,
}

export const SendBack = {
  Message: "message" as const,
}

